/** Aromahpure premium design tokens — single source for theme + CSS. */

export const FONT_STACK =
  '-apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

export const radius = {
  sm: 8,
  md: 12,
  lg: 16,
};

export const space = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  7: 32,
  8: 40,
  9: 48,
};

export const light = {
  bg: '#F5F5F7',
  surface: '#FFFFFF',
  text: '#1D1D1F',
  textSecondary: 'rgba(60, 60, 67, 0.64)',
  hairline: 'rgba(60, 60, 67, 0.12)',
  accent: '#5E7168',
  accentHover: '#45554E',
  accentMuted: 'rgba(94, 113, 104, 0.12)',
  success: '#34C759',
  warning: '#FF9F0A',
  error: '#FF3B30',
};

export const dark = {
  bg: '#1C1C1E',
  surface: '#2C2C2E',
  text: '#F5F5F7',
  textSecondary: 'rgba(235, 235, 245, 0.6)',
  hairline: 'rgba(255, 255, 255, 0.1)',
  accent: '#5E7168',
  accentHover: '#8A9B92',
  accentMuted: 'rgba(94, 113, 104, 0.28)',
  success: '#34C759',
  warning: '#FF9F0A',
  error: '#FF3B30',
};

export const DRAWER_WIDTH = 280;

/** Soft elevation scale (25 levels) for MUI shadows. */
export function buildSoftShadows() {
  const list = ['none'];
  for (let i = 1; i < 25; i += 1) {
    const y = Math.min(2 + i * 0.45, 14);
    const blur = Math.min(4 + i * 0.9, 28);
    const a1 = Math.min(0.03 + i * 0.004, 0.1);
    const a2 = Math.min(0.015 + i * 0.0025, 0.05);
    list.push(
      `0 ${y.toFixed(1)}px ${blur.toFixed(1)}px rgba(15, 23, 20, ${a1.toFixed(3)}), 0 1px 2px rgba(15, 23, 20, ${a2.toFixed(3)})`
    );
  }
  return list;
}
